import React, {Component} from 'react'
import {FormControl} from 'react-bootstrap'
import {Actions} from 'jumpstate'

class HorseName extends Component {
  constructor (props) {
    super(props)
    this.state = {
      term: '',
      termFa: '',
      errors: [],
      touched: []
    }
    this.saveName = this.saveName.bind(this)
    this.saveTranslation = this.saveTranslation.bind(this)
    this.validate = this.validate.bind(this)
    Actions.setAllNewHorseFieldsTouched(false)
  }

  componentWillMount () {
    const {name, nameFa, errors, touched} = this.props
    this.setState({
      term: name,
      termFa: nameFa,
      errors: errors,
      touched: touched
    })
  }

  componentWillReceiveProps (nextProps) {
    const {name, nameFa, errors, touched} = nextProps
    this.setState({
      term: name,
      termFa: nameFa,
      errors: errors,
      touched: touched
    })
  }

  saveName (e) {
    const value = e.target.value
    this.setState({term: value})
    Actions.setNewHorseDetails({name: value})
  }

  saveTranslation (e) {
    const value = e.target.value
    this.setState({termFa: value})
    Actions.setNewHorseDetails({name_fa: value})
  }

  validate (e) {
    Actions.addNewHorseTouched(e.target.name)
    Actions.validateNewHorseData()
  }

  render () {
    const {placeholder} = this.props
    const {errors, touched} = this.state
    const hasError = (fieldName) => {
      if (touched && errors) {
        if (touched.indexOf(fieldName) !== -1) {
          return !!errors[fieldName]
        }
      }
    }

    return (
      <div>
        <FormControl
          placeholder={placeholder}
          name="name_fa"
          type="text"
          defaultValue={this.state.termFa}
          className={`Name blink ${hasError('name_fa') ? 'form-component-error' : ''}`}
          onChange={this.saveTranslation}
          onBlur={this.validate}
        />
        <FormControl
          defaultValue={this.state.term}
          name="name"
          placeholder="معادل انگلیسی"
          type="text"
          className={`Name blink ${hasError('name') ? 'form-component-error' : ''}`}
          onChange={this.saveName}
          onBlur={this.validate}
        />
      </div>
    )
  }
}

HorseName.propTypes = {
  name: React.PropTypes.string.isRequired,
  nameFa: React.PropTypes.string,
  placeholder: React.PropTypes.string.isRequired,
  errors: React.PropTypes.object,
  touched: React.PropTypes.array
}

export default HorseName



// WEBPACK FOOTER //
// ./src/components/NewHorse/HorseName/HorseName.js